import type { SVGProp } from './types';

export const chevronUp = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="m12.7524 8.50274 5.65 5.65996c.0938.093.1682.2036.2189.3255.0508.1218.0769.2525.0769.3845 0 .1321-.0261.2628-.0769.3846-.0507.1219-.1251.2325-.2189.3254-.1873.1863-.4408.2908-.705.2908-.2641 0-.5176-.1045-.705-.2908l-5-4.95-4.94996 4.95c-.18736.1863-.44081.2908-.705.2908-.26418 0-.51763-.1045-.705-.2908-.09448-.0926-.16965-.203-.22115-.3249-.0515-.1219-.0783-.2527-.07884-.3851.00054-.1323.02734-.2631.07884-.385.0515-.1219.12667-.2323.22115-.325l5.64996-5.65996c.0937-.1015.2073-.18251.3338-.23792.1265-.05541.2631-.08401.4012-.08401.1381 0 .2748.0286.4012.08401.1265.05541.2402.13642.3338.23792Z"
      fill="currentColor"
    />
  </svg>
);
